<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <ng-container *ngIf="mode === 'delete'">
    <p><strong>Are you sure you want to delete <span class="text-primary">"{{ itemName }}"</span>?</strong></p>
    <p class="text-danger" *ngIf="!hideDeleteAssociatedItem">All associated information will be permanently
      deleted and cannot be restored.
    </p>
  </ng-container>
  <ng-container *ngIf="mode === 'custom'">
    <p><strong>{{ body }}</strong></p>
  </ng-container>
  <ng-container *ngIf="mode === 'request_changes'">
    <p><strong>{{ body }}</strong></p>
    <label class="form-label mt-2">{{ inputLabel }}</label>
    <textarea class="form-control" rows="4" [value]="inputValue" [placeholder]="inputPlaceholder"
              (input)="inputValue = $any($event.target).value"></textarea>
    <small class="text-danger" *ngIf="showInputError">Please provide request details.</small>
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss('cancel click')">Cancel</button>
  <button type="button" class="btn btn-danger" (click)="confirm()">{{ confirmButton || 'Delete' }}</button>
</div>
